import { useMemo } from 'react';

import { useTypedSelector } from 'hooks/useTypedSelector';
import {
  FORM_UUID_GENERAL_PRESCREENING,
  FORM_UUID_TRAVEL_CLINIC,
  FORM_UUID_WEIGHT_LOSS_CLINIC,
} from 'constants/app.constants';

export const useShowFormNHSLogo = (): { showFormNHSLogo: boolean } => {
  const formUuid = useTypedSelector(state => state.form.formUuid);

  const showFormNHSLogo = useMemo(
    () =>
      formUuid !== FORM_UUID_TRAVEL_CLINIC &&
      formUuid !== FORM_UUID_GENERAL_PRESCREENING &&
      formUuid !== FORM_UUID_WEIGHT_LOSS_CLINIC,
    [formUuid],
  );

  return { showFormNHSLogo };
};
